import { LocalStorageKey } from '@/shared/constants/storageKeys';

const ALPHA_NUMERIC_REGEX = /[^a-zA-Z0-9_-]/g;

const url = new URL(window.location.href);
const searchParamsReferral = url.searchParams.get(LocalStorageKey.REFERRAL)?.replace(ALPHA_NUMERIC_REGEX, '');
const referral = localStorage.getItem(LocalStorageKey.REFERRAL) ?? searchParamsReferral;

if (referral) {
  localStorage.setItem(LocalStorageKey.REFERRAL, referral);
}

export const initialState = {
  referral,
};
